



























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import url from '@/lib/url'
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import ListView from '@/components/helper/list-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import ManufacturerForm from './manufacturer-form.vue';

class PageManufacturerRequest extends PageRequest {
}

@Component({
    components: { ListView, ManufacturerForm, FormBase }
})
export default class Manufacturers extends ListBase {
    entity: string = 'manufacturer';
    pagerequest: PageManufacturerRequest = new PageManufacturerRequest();

    columns = [
        this.gCol('name', 'Nombre', 'text'),
        this.gCol('active', 'Habilitado', 'text'),
        this.defaultActions('edit')
    ]

    edit() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }
    async afterSave() {
        let list: any = this.$refs.listView
        await list.getpage();
    }     

    mounted() {
        
    }

    created() {
        
    }
}